export const storelist = {
  seoulList: [
    '가로수길',
    '강남',
    '강서\n홈플러스',
    '건대',
    '노원역',
    '대학로',
    '목동',
    '서울대\n입구역',
    '수유',
    '신림',
    '신촌',
    '연신내',
    '영등포',
    '이수역',
    '잠실롯데\n월드타워',
    '잠실\n새내역',
    '종로',
    '천호',
    '합정',
  ],

  gyeonggiList: [
    '동탄\n하나로마트',
    '동탄',
    '범계',
    '부천',
    '분당\n서현',
    '분당\n야탑',
    '산본',
    '수원\n시청역',
    '수원',
    '수지',
    '의정부\n홈플러스',
    '일산',
    '평택',
    '화정',
  ],
  othersList: [
    '광주\n상무',
    '광주\n충정로',
    '김해',
    '대구\n동성로',
    '대구\n상인',
    '대전\n시청역',
    '대전\n은행',
    '동대구역',
    '마산\n합정',
    '부산 경성대\n부경대역',
    '부산\n덕천',
    '부산\n서면동보',
    '부산\n서면',
    '부산\n센텀',
    '울산',
    '인천 계산\n홈플러스',
    '인천\n구월',
    '인천\n송도',
    '인천\n청라',
    '전주',
    '창원\n상남',
    '천안신불당',
    '청주',
  ],
};
